export default __webpack_public_path__ + "static/software-2-7b89e711aea4395200dbc4074c3db4fe.webp";